import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { AcompanhamentosCard } from './components';
import { useAcompanhamentosListagem, useAcompanhamentosNavegacao } from './hooks';
import PageHeader from '@spark/ui-components/components/BreadCrumb';

const AcompanhamentosMain = () => {
  const {
    data,
    loading,
    error,
    handleFilterChange
  } = useAcompanhamentosListagem();
  const {
    handleRowClick,
    handleAdicionar
  } = useAcompanhamentosNavegacao();
  return <Container fluid>
      <Row>
        <Col md={12}>
          <PageHeader title="" routeSegments={[{
          name: 'Início'
        }, {
          name: 'Acompanhamentos'
        }]} />
        </Col>
      </Row>
      
      <Row>
        <Col md={12}>
          <AcompanhamentosCard data={data} loading={loading} error={error} onFilterChange={handleFilterChange} onRowClick={handleRowClick} onAdicionar={handleAdicionar} />
        </Col>
      </Row>
    </Container>;
};

export default AcompanhamentosMain;
